// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sections{width:100%}.sections-loop-column{display:flex;flex-direction:column}@media screen and (min-width:767px){.sections-loop-column{align-items:flex-start;flex-direction:row;flex-wrap:wrap;justify-content:space-between}.sections-loop-column section{max-width:500px;width:48%}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
